import React from 'react'
import PropTypes from 'prop-types'
import DivIcon from './DivIcon'

const Reactivate = ({ color, width, height, marginRight, marginTop }) => (
  <DivIcon marginRight={marginRight} marginTop={marginTop}>
    <svg width={width} height={height} viewBox='0 0 18 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6 10.17L2.53 6.70001C2.14 6.31001 1.51 6.31001 1.12 6.70001C0.729999 7.09001 0.729999 7.72001 1.12 8.11001L5.3 12.29C5.69 12.68 6.32 12.68 6.71 12.29L17.29 1.71001C17.68 1.32001 17.68 0.690007 17.29 0.300007C16.9 -0.0899927 16.27 -0.0899927 15.88 0.300007L6 10.17Z'
        fill={color}
      />
    </svg>
  </DivIcon>
)

Reactivate.defaultProps = {
  color: '#989898',
  width: '15',
  height: '12',
}

Reactivate.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Reactivate
